<template>
    <div id="leftnavdefault_main" class="ff-inter fs-small">
        <router-link class="leftnavdefault_main_router tx-none bg-faded fc-gray-dark bt-hover-dark" :to="{name: 'Dashboard'}">
            <i class="fas fa-chart-bar fs-big"></i>
            <div class="leftnavdefault_main_router_inner">
                Dashboard
            </div>
        </router-link>
        <router-link v-if="project ? project.project.kvstorages[0] : null" class="leftnavdefault_main_router tx-none bg-faded fc-gray-dark bt-hover-dark" :to="{name: 'Kv'}">
            <i class="fas fa-database fs-big"></i>
            <div class="leftnavdefault_main_router_inner">
                Datastorage
            </div>
        </router-link>
        <router-link v-if="project ? project.project.filestorages[0] : null" class="leftnavdefault_main_router tx-none bg-faded fc-gray-dark bt-hover-dark" :to="{name: 'Fs'}">
            <i class="fas fa-folder fs-big"></i>
            <div class="leftnavdefault_main_router_inner">
                Filestorage
            </div>
        </router-link>
    </div>
</template>

<script>
  export default {
    name: 'leftNavDefault',
    components: {  },
    data(){
      return{

      }
    },
    computed:{
        project(){
          return this.$store.getters['Projects/get_project']
        }
    },
    methods:{

    }
  }
</script>

<style scoped>
    #leftnavdefault_main{
        display: flex;
        height: 100%;
        width: 100%;
        flex-direction: column;
    }
    .leftnavdefault_main_router{
        display: flex;
        height: 50px;
        width: 100%;
        justify-content: center;
        align-items: center;
    }
    .leftnavdefault_main_router_inner{
        display: flex;
        width: calc(100% - 100px);
    }
    .leftnavdefault_main_router_inner{
       margin-left: 10px;
    }
    .router-link-exact-active{
        background-color: var(--color-main-faded);
        color: var(--color-main);
    }
</style>
